//
// { 0: value, 1: value, 2: value } 形式の
// オブジェクトを操作するためのユーティリティをまとめている
//

const _reorderObject = (object) => {
  let idx = 0;
  let res = {};
  const keys = Object.keys(object)
    .map((key) => parseInt(key))
    .sort((a, b) => {
      return a - b;
    });
  for (let key of keys) {
    res[idx] = object[key];
    idx += 1;
  }

  return cloneObject(res);
};

// keyを削除しソートし直す
export const deleteAtIndex = (object, idx) => {
  delete object[idx];
  return _reorderObject(object);
};

// idxのitemの次にvalueを挿入する
// 例
// let object = { 0: 'a', 1: 'b', 2: 'c', 3: 'd' }
// appendValue(object,

// idx < 0の場合、最後に追加する
export const appendValue = (_object, value, idx) => {
  let object = JSON.parse(JSON.stringify(_object));
  const keys = Object.keys(object).sort();

  if (idx < 0) {
    object[keys.length] = value;
    return object;
  } else if (idx >= keys.length) {
    object[idx] = value;
    return object;
  } else {
    const res = {};
    for (let _idx of keys) {
      _idx = parseInt(_idx, 10);
      if (_idx < idx) {
        // 手前
        res[_idx] = object[_idx];
      } else if (_idx === idx) {
        // 挿入位置にきたとき
        res[_idx] = value;
        res[_idx + 1] = object[_idx];
      } else {
        // そのあと
        res[_idx + 1] = object[_idx];
      }
    }
    return res;
  }
};

// index1とindex2のvalueを入れ替える
export const replaceIndex = (object, index1, index2) => {
  const item1 = object[index1];
  const item2 = object[index2];
  object[index1] = item2;
  object[index2] = item1;

  return _reorderObject(object);
};

// objectのlengthを返す
export const getObjectLength = (object) => {
  const keys = Object.keys(object);
  return keys.length;
};

export const cloneObject = (object) => {
  return JSON.parse(JSON.stringify(object));
};

export const dumpObject = (object) => {
  console.debug(cloneObject(object));
};
